import { memo, useMemo } from "react";
import { htmlToText } from "@onair/utils/html-to-text";
import CardPostSimple from "./card-post-simple";
import CardPost from "./card-post";
import Link from "next/link";
import { PostListResponse } from "@onair/repositories";

interface PostListProps {
	items: Exclude<PostListResponse["data"], undefined>;
}
const PostList: React.FC<PostListProps> = ({ items }) => {
	const twoFirstPost = useMemo(() => {
		return [...items].splice(0, 2);
	}, [items]);
	const sixNextPosts = useMemo(() => {
		return [...items].splice(2, 6);
	}, [items]);
	return (
		<>
			<div className="first-section two-latest-post grid grid-cols-1 md:grid-cols-2 gap-6">
				{twoFirstPost.map((post) => (
					<div key={post.id} className="post-item group/item">
						<Link href={getUrlPost(post.slug)}>
							<div className="post-item__thumbnail bg-slate-100 w-full aspect-[9/5] overflow-hidden">
								<img
									src={post.banner.url}
									alt={post.title}
									className="w-full h-full object-cover"
								/>
							</div>
							<div className="pt-6">
								<h3 className="text-lg lg:text-[1.5rem] leading-snug font-bold line-clamp-3 group-hover/item:underline underline-offset-3">
									{post.title}
								</h3>
							</div>
						</Link>
					</div>
				))}
			</div>
			<div className="h-8 lg:h-12"></div>
			<div className="post-list-seconds grid grid-cols-1 md:grid-cols-3 gap-6">
				{[...sixNextPosts].map((post) => (
					<CardPost
						key={post.id}
						title={post.title}
						description={trimWords(htmlToText(post.content || ""), 40)}
						thumbnailUrl={post.banner.url}
						href={getUrlPost(post.slug)}
						createdAt={post.createdAt}
					/>
				))}
			</div>
			<div className="h-8 lg:h-12"></div>
			<div className="post-list-seconds grid grid-cols-1 md:grid-cols-3 gap-6">
				{[...items].slice(8).map((post) => (
					<CardPostSimple
						key={post.id}
						title={post.title}
						href={getUrlPost(post.slug)}
						createdAt={post.createdAt}
						//@ts-ignore
						hashTags={post.hashtags}
					/>
				))}
			</div>
		</>
	);
};
export default memo(PostList);

function trimWords(text?: string, wordLimit = 100) {
	if (!text) return "";

	const words = text.trim().split(/\s+/);
	if (words.length <= wordLimit) return text;
	return words.slice(0, wordLimit).join(" ") + "...";
}
const getUrlPost = (slug: string) => {
	return `/post/${slug}`;
};
